import { heartRunnerListState } from '../state/heartRunnerListState'
import {
    FETCH_HEARTRUNNER_LIST_REQUEST, FETCH_HEARTRUNNER_LIST_SUCCESS, FETCH_HEARTRUNNER_LIST_ERROR,
    FETCH_HEARTRUNNER_ORG_REQUEST, FETCH_HEARTRUNNER_ORG_SUCCESS,
    UPDATE_HEARTRUNNER_LIST_REQUEST, UPDATE_HEARTRUNNER_LIST_SUCCESS, UPDATE_HEARTRUNNER_LIST_ERROR,
    UPDATE_DEVICE_DETAILS_REQUEST, UPDATE_DEVICE_DETAILS_SUCCESS, UPDATE_DEVICE_DETAILS_ERROR,
    Logout_User_Success,Fetch_All_Region_Data1
} from '../actions/heartRunnerListAction'
import {
    INSERT_HEARTRUNNER_DETAILS_REQUEST, INSERT_HEARTRUNNER_DETAILS_SUCCESS, INSERT_HEARTRUNNER_DETAILS_ERROR,
    FETCH_COUNTRY_LIST_DATA,FETCH_REGION_LIST_DATA,FETCH_PERMISSIONS_LIST_DATA
} from '../actions/heartRunnerAction';
var initialStatusCode=''

export function heartRunnerReducer(state = heartRunnerListState, action) {
    switch (action.type) {
         case Fetch_All_Region_Data1:
                    return Object.assign({}, state, {
                        errorCode : action.errorCode,
                        statusCode : action.statusCode,
                        regionList : action.regionList
                    })
        case FETCH_HEARTRUNNER_LIST_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                messageLabel:'',
                statusCode:initialStatusCode
         })
        case FETCH_HEARTRUNNER_LIST_SUCCESS:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                heartRunnerList: action.heartRunnerList,
                statusCode : action.statusCode
            })
        case FETCH_HEARTRUNNER_LIST_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage
            })
        case FETCH_HEARTRUNNER_ORG_REQUEST:
                return Object.assign({}, state, {
                    
                    isLoading: action.isLoading,
                    statusCode:initialStatusCode
                })
        case FETCH_HEARTRUNNER_ORG_SUCCESS:
            
            return Object.assign({}, state, {
                heartRunnerOrgInfo:action.heartRunnerOrgInfo,
                isLoading: action.isLoading,
                Message: action.Message,
            })
        case UPDATE_HEARTRUNNER_LIST_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                statusCode:initialStatusCode,
                messageLabel : ''
            })
        case UPDATE_HEARTRUNNER_LIST_SUCCESS:
            // //debugger
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                heartRunnerList: action.heartRunnerList,
                messageLabel: action.messageLabel,
                statusCode:action.statusCode
            })
        case UPDATE_HEARTRUNNER_LIST_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage
            })
        case INSERT_HEARTRUNNER_DETAILS_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                statusCode:initialStatusCode

            })
        case INSERT_HEARTRUNNER_DETAILS_SUCCESS:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                heartRunnerList: action.heartRunnerList,
                errorMessage: action.errorMessage,
                statusCode:action.statusCode
            })
        case INSERT_HEARTRUNNER_DETAILS_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage
            })
        case UPDATE_DEVICE_DETAILS_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                statusCode: action.statusCode
            })
        case UPDATE_DEVICE_DETAILS_SUCCESS:        
            return Object.assign({}, state, {
                isLoading: action.isLoading, 
                messageLabel: action.messageLabel,
                statusCode:action.statusCode
            })
        case UPDATE_DEVICE_DETAILS_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage
            })
        case Logout_User_Success:
            return Object.assign({}, state,{
                errorNumber: action.errorCode,
                messageLabel: action.message,    
                statusCode: action.statusCode
            })
        case FETCH_COUNTRY_LIST_DATA:
            return Object.assign({}, state, {
                countryList : action.list
            })
            case FETCH_REGION_LIST_DATA:
            return Object.assign({}, state, {
                regionList : action.list
            })
          case FETCH_PERMISSIONS_LIST_DATA:
            return Object.assign({}, state, {
                permissionList : action.list
            })
        default:
            return state;
    }
}
